import * as React from 'react'
import { useState, useEffect } from 'react'
import CustomDataGrid from '../components/CustomDataGrid'
import EntityDetails from '../components/EntityDetails'
import { Spinner, Alert } from 'react-bootstrap'
import {
  generateFormData,
  respondedMapping,
  campaignMapping,
  contactVisitsMapping,
  generateGridColumns,
  campaignGridColumns,
  respondedGridColumns,
  contactVisitsGridColumns,
  campaignRowMapping,
  generateGridRows,
  respondedRowMapping,
  contactVisitsRowMapping,
  formatUtcToLocal
} from '../utils/PageUtils'
import {
  fetchCampaigns,
  fetchRespondedContacts,
  fetchContactVisits,
} from '../utils/api'
import PageHelmet from '../components/PageHelmet'
import '../styles/Dashboard.css'
import PropTypes from 'prop-types'
import { IconButton } from "@mui/material";
import { MdArrowBackIos } from "react-icons/md";

function Dashbaord({ userRole, bearerToken }) {
  const [campaignsData, setCampaignsData] = useState([])
  const [campaignError, setCampaignError] = useState(null)
  const [campaignInfo, setCampaignInfo] = useState(null)
  const [selectedCampaign, setSelectedCampaign] = useState(null)
  const [campaignRowId, setCamapaignRowId] = useState(null)
  const [campaignsLoading, setCampaignsLoading] = useState(false)

  const [records, setRecords] = useState([])
  const [respondError, setRespondError] = useState(null)
  const [respondInfo, setRespondInfo] = useState(null)
  const [selectedContact, setSelectedContact] = useState(null)
  const [contactRowId, setContactRowId] = useState(null)
  const [respondLoading, setRespondLoading] = useState(false)

  const [visits, setVisits] = useState([])
  const [visitError, setVisitError] = useState(null)
  const [selectedVisit, setSelectedVisit] = useState(null)
  const [visitsRowId, setVisitsRowId] = useState(null)
  const [visitsLoading, setVisitsLoading] = useState(false)
  const [isMobile, setIsMobile] = useState(false);


  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 768);
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  useEffect(() => {
    setCampaignError(null)
    setCampaignInfo(null)
    setCampaignsLoading(true)

    const fetchCampaignsData = async () => {
      if (!bearerToken) {
        console.warn('No access token available')
        return
      }
      try {
        const response = await fetchCampaigns(bearerToken)
        console.log('fetchCampaignsData response', response)

        switch (response.status) {
          case 200:
            {
              const data = response.data
              setCampaignsData(data.records)
              break
            }
          case 400:
            setCampaignError(
              'Something went wrong while attempting to display data on the screen.',
            )
            break

          case 404:
            setCampaignInfo(' No existing campaigns were found for this user.')
            break

          case 500:
            setCampaignError(
              'Something went wrong while attempting to display data on the screen.',
            )
            break

          default:
            setCampaignError(
              'Something went wrong while attempting to display data on the screen.',
            )
        }
      } catch {
        setCampaignError(
          'Something went wrong while attempting to display data on the screen.',
        )
      } finally {
        setCampaignsLoading(false)
      }
    }

    fetchCampaignsData()
  }, [])

  useEffect(() => {
    if (!selectedCampaign) return
    const fetchRespondedData = async () => {
      setRespondLoading(true)
      setRespondError(null)
      setRespondInfo(null)
      try {
        const response = await fetchRespondedContacts(
          selectedCampaign.campaign_name,
          bearerToken,
        )
        console.log('fetchRespondedData response', response)
        switch (response.status) {
          case 200: {
            const data = await response.data
            setRecords(data.records)
            break
          }
          case 400:
            setRespondError(
              'Something went wrong while attempting to display data on to the screen',
            )
            break

          case 404:
            setRespondInfo('No responses to this campaign yet')
            break

          case 500:
            setRespondError(
              'Something went wrong while attempting to display data on to the screen',
            )
            break

          default:
            setRespondError(
              'Something went wrong while attempting to display data on to the screen',
            )
        }
      } catch {
        setRespondError(
          'Something went wrong while attempting to display data on to the screen',
        )
      } finally {
        setRespondLoading(false)
      }
    }
    fetchRespondedData()
  }, [selectedCampaign])

  useEffect(() => {
    if (!selectedContact) return
    const fetchContactData = async () => {
      setVisitError(null)
      setVisitsLoading(true)
      console.log('useEffect triggered by selectedContact:', selectedContact)
      try {
        const trackable = selectedContact.trackable
        const response = await fetchContactVisits(trackable, bearerToken)
        console.log('fetchContactData response', response)
        switch (response.status) {
          case 200:
            {
              const data = await response.data
              setVisits(data.records)
              console.log('related response', data.records)
              break
            }
          case 400:
            setVisitError(
              'Something went wrong while attempting to display data on to the screen',
            )
            break

          case 404:
            setVisitInfo('No visits were found for this contact')
            break

          case 500:
            setVisitError(
              'Something went wrong while attempting to display data on to the screen',
            )
            break

          default:
            setVisitError(
              'Something went wrong while attempting to display data on to the screen',
            )
        }
      } catch {
        setVisitError(
          'Something went wrong while attempting to display data on to the screen',
        )
      } finally {
        setVisitsLoading(false)
      }
    }

    fetchContactData()
  }, [selectedContact])

  const visitsDataset = visits?.map((record) => ({
    ...record,
    visited: formatUtcToLocal(record.visited),
  }));

  console.log('visitsDataset', visitsDataset);

  const campaignFormData = selectedCampaign
    ? generateFormData(selectedCampaign, campaignMapping)
    : null
  const campaignColumns = generateGridColumns(
    campaignGridColumns,
    'campaign_name',
  )
  const campaignRows = generateGridRows(campaignsData, campaignRowMapping)

  const respondedFormData = selectedContact
    ? generateFormData(selectedContact, respondedMapping)
    : null
  const respondedColumns = generateGridColumns(
    respondedGridColumns,
    'greeting_name',
  )
  const respondedRows = generateGridRows(records, respondedRowMapping)

  const visitsFormData = selectedVisit
    ? generateFormData(selectedVisit, contactVisitsMapping)
    : null
  const visitsColumns = generateGridColumns(contactVisitsGridColumns, 'visited')
  const visitsRows = generateGridRows(visitsDataset, contactVisitsRowMapping)

  function handleCampaignClick(e) {
    if (campaignRowId === e.id) {
      setCamapaignRowId(null)
      setSelectedCampaign(null)
      setSelectedContact(null)
      setSelectedVisit(null)
    } else {
      const selected = campaignsData[e.id - 1]
      setSelectedCampaign(selected)
      setCamapaignRowId(e.id)
    }

  }

  const handleContactClick = (e) => {

    if (contactRowId === e.id) {
      setSelectedContact(null);
      setContactRowId(null)
    } else {
      const selected = records[e.id - 1]
      setSelectedContact(selected)
      setContactRowId(e.id)
    }
  }

  const handleVisitClick = (e) => {
    const selected = visits[e.id - 1]
    setSelectedVisit(selected)
    setVisitsRowId(e.id)

    if (visitsRowId === e.id) {
      setVisitsRowId(null)
      setSelectedVisit(null)
    } else {
      const selected = visits[e.id - 1]
      setSelectedVisit(selected)
      setVisitsRowId(e.id)
    }
  }
  if (campaignsLoading) {
    return (
      <div className="loading-container">
        <Spinner animation="border" role="status" />
        <p>Please wait...</p>
      </div>
    )
  }
  let content;

  if (campaignInfo) {
    content = (
      <div className="no-campaigns">
        <Alert variant="primary">{campaignInfo}</Alert>
      </div>
    );
  } else if (campaignError) {
    content = (
      <div className="no-campaigns">
        <Alert variant="danger">{campaignError}</Alert>
      </div>
    );
  } else {
    content = (
      <div className="create-grid-container">
        <h4
          className="subheading"
          data-testid="dashboard-headings"
          style={{ color: '#2f539b' }}
        >
          Click Campaign for Stats
        </h4>
        <CustomDataGrid
          rows={campaignRows}
          columns={campaignColumns}
          totalRows={campaignsData.length}
          onRowClick={handleCampaignClick}
          selectedRowId={campaignRowId}
        />
      </div>
    );
  }
  const renderDetailsCard = (title, data) => (
    <div className="dashboard-details-card">
      <div className="details-header-area">
        <p className="details-title-top">{title}</p>
      </div>
      <div className="details-body-content">
        <div className="details-content-box">
          {data.map((field, idx) => (
            <div className="details-row-item" key={idx}>
              <p className="details-label-text">{field.label}:</p>
              <p className="details-value-text">{field.value}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );


  return userRole === 'customer' ? (
    <div className={`campaign-dashboard-container ${(selectedCampaign || selectedContact || selectedVisit) ? 'has-selection' : ''
      }`}>
      <PageHelmet
        title="Campaign Dashboard"
        description="Track campaigns."
        url={`${process.env.REACT_APP_COGNITO_REDIRECT_URL}/campaign_dashboard`}
      />

      <h1 className="main-heading" data-testid="dashboard-headings">
        Dashboard
      </h1>

      <div className="dashboard-container">
        <div
          className={`create-grid-form ${selectedCampaign ? 'grid-to-left' : 'grid-centered'
            } `}
        >
          {content}
          {!isMobile && selectedCampaign && (
            <div className="create-form-container">
              {renderDetailsCard("Campaign Details", campaignFormData)}
            </div>
          )}
        </div>
      </div>

      {/* Desktop View for Responded Contacts */}
      {!isMobile && selectedCampaign && (
        <div className="dashboard-container custom-container">
          {respondLoading && (
            <div className="proof-note">
              <Spinner animation="border" variant="primary" />
              <p>Loading...</p>
            </div>
          )}
          {respondError && (
            <div className="dashboard-msg">
              <Alert variant="danger">{respondError}</Alert>
              {respondError}
            </div>
          )}
          {respondInfo && (
            <div className="dashboard-msg">
              <Alert variant="primary" data-testid="respondInfo">
                {respondInfo}
              </Alert>
            </div>
          )}
          <div
            className={`create-grid-form ${selectedContact ? 'grid-to-left' : 'grid-centered'}`}
          >
            {!respondLoading && !respondError && !respondInfo && (
              <div className="create-grid-container">
                <h4
                  className="subheading"
                  data-testid="dashboard-headings"
                >
                  <span className="section-indicator"></span>
                  Responded Contacts
                </h4>
                <CustomDataGrid
                  rows={respondedRows}
                  columns={respondedColumns}
                  totalRows={records.length}
                  onRowClick={handleContactClick}
                  selectedRowId={contactRowId}
                />
              </div>
            )}
            {respondedFormData && (
              <div className="create-form-container">
                {renderDetailsCard("Contact Details", respondedFormData)}
              </div>
            )}
          </div>
        </div>
      )}

      {/* Desktop View for Contact Visits */}
      {!isMobile && selectedContact && (
        <div className="dashboard-container">
          <div
            className={`create-grid-form ${selectedVisit ? 'grid-to-left' : 'grid-centered'
              } `}
          >
            {visitsLoading && (
              <div className="proof-note">
                <Spinner animation="border" variant="primary" />
                <p>Loading...</p>
              </div>
            )}
            {visitError && (
              <div className="dashboard-msg">
                <Alert variant="danger">{visitError}</Alert>
              </div>
            )}

            {!visitsLoading && !visitError && (
              <div className="create-grid-container">
                <h4
                  className="subheading"
                  data-testid="dashboard-headings"
                >
                  <span className="section-indicator"></span>
                  Contact Visits
                </h4>
                <CustomDataGrid
                  rows={visitsRows}
                  columns={visitsColumns}
                  totalRows={visits.length}
                  onRowClick={handleVisitClick}
                  selectedRowId={visitsRowId}
                />
              </div>
            )}
            {visitsFormData && (
              <div id="form-testId" className="create-form-container">
                {renderDetailsCard("Visit Details", visitsFormData)}
              </div>
            )}
          </div>
        </div>
      )}

      {/* Screen 2: Campaign Details Form + Responded Contacts Grid */}
      {isMobile && selectedCampaign && (
        <div className="campaign-mobile-overlay mobile-open" style={{ zIndex: 1200 }}>
          <div className="mobile-header">
            <IconButton size="small" style={{ color: '#fff' }} onClick={() => setSelectedCampaign(null)}>
              <MdArrowBackIos />
            </IconButton>
          </div>
          <div className="details-body-content" style={{ marginTop: '20px', paddingBottom: '100px' }}>
            {renderDetailsCard("Campaign Details", campaignFormData)}

            <div className="dashboard-container" style={{ marginTop: '20px', border: 'none', background: 'transparent', padding: 0 }}>
              {respondLoading && <Spinner animation="border" variant="primary" />}
              {respondError && <Alert variant="danger">{respondError}</Alert>}
              {respondInfo && <Alert variant="primary">{respondInfo}</Alert>}

              {!respondLoading && !respondError && !respondInfo && (
                <div style={{ marginTop: '20px' }}>
                  <h4 className="subheading">
                    <span className="section-indicator"></span>
                    Responded Contacts
                  </h4>
                  <CustomDataGrid
                    rows={respondedRows}
                    columns={respondedColumns}
                    totalRows={records.length}
                    onRowClick={handleContactClick}
                    selectedRowId={contactRowId}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Screen 3: Contact Details Form + Visits Grid */}
      {isMobile && selectedContact && (
        <div className="campaign-mobile-overlay mobile-open" style={{ zIndex: 1300 }}>
          <div className="mobile-header">
            <IconButton size="small" style={{ color: '#fff' }} onClick={() => setSelectedContact(null)}>
              <MdArrowBackIos />
            </IconButton>
          </div>
          <div className="details-body-content" style={{ marginTop: '20px', paddingBottom: '100px' }}>
            {renderDetailsCard("Contact Details", respondedFormData)}

            <div className="dashboard-container" style={{ marginTop: '20px', border: 'none', background: 'transparent', padding: 0 }}>
              {visitsLoading && <Spinner animation="border" variant="primary" />}
              {visitError && <Alert variant="danger">{visitError}</Alert>}

              {!visitsLoading && !visitError && (
                <div style={{ marginTop: '20px' }}>
                  <h4 className="subheading">
                    <span className="section-indicator"></span>
                    Contact Visits
                  </h4>
                  <CustomDataGrid
                    rows={visitsRows}
                    columns={visitsColumns}
                    totalRows={visits.length}
                    onRowClick={handleVisitClick}
                    selectedRowId={visitsRowId}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Screen 4: Visit Details Form */}
      {isMobile && selectedVisit && (
        <div className="campaign-mobile-overlay mobile-open" style={{ zIndex: 1400 }}>
          <div className="mobile-header">
            <IconButton size="small" style={{ color: '#fff' }} onClick={() => setSelectedVisit(null)}>
              <MdArrowBackIos />
            </IconButton>
          </div>
          <div className="details-body-content" style={{ marginTop: '20px' }}>
            {renderDetailsCard("Visit Details", visitsFormData)}
          </div>
        </div>
      )}
    </div>
  ) : (
    <div className="user-container">
      <Alert variant="danger">You do not have access to this page.</Alert>
    </div>
  )
}

Dashbaord.propTypes = {
  userRole: PropTypes.string.isRequired,
  bearerToken: PropTypes.string.isRequired,
}


export default Dashbaord
